import { render, staticRenderFns } from "./coderOutpatientReviewPage.vue?vue&type=template&id=4521a4d6&scoped=true&"
import script from "./coderOutpatientReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientReviewPage.vue?vue&type=style&index=0&id=4521a4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521a4d6",
  null
  
)

export default component.exports